/* Hover-open for the header mega menu — progressive enhancement over Dawn's
   native <details> disclosure. Active ONLY on hover-capable fine pointers;
   touch keeps native first-tap-opens, keyboard keeps native Enter/Escape
   (global.js + details-disclosure.js). Mouse click on an open summary
   navigates to its data-url instead of re-toggling. */
(() => {
  const mq = window.matchMedia('(hover: hover) and (pointer: fine)');
  const GRACE_MS = 150;
  let timers = new WeakMap();

  function open(details) {
    details.setAttribute('open', '');
    details.querySelector('summary').setAttribute('aria-expanded', 'true');
  }

  function close(details) {
    details.removeAttribute('open');
    details.querySelector('summary').setAttribute('aria-expanded', 'false');
  }

  function bind() {
    document.querySelectorAll('.header__inline-menu header-menu > details.mega-menu').forEach((details) => {
      const li = details.closest('li');
      const summary = details.querySelector('summary');

      li.addEventListener('pointerenter', (e) => {
        if (!mq.matches || e.pointerType !== 'mouse') return;
        clearTimeout(timers.get(li));
        document.querySelectorAll('.header__inline-menu details.mega-menu[open]').forEach((other) => {
          if (other !== details) close(other);
        });
        open(details);
      });

      li.addEventListener('pointerleave', (e) => {
        if (!mq.matches || e.pointerType !== 'mouse') return;
        timers.set(li, setTimeout(() => close(details), GRACE_MS));
      });

      summary.addEventListener('click', (e) => {
        // e.detail === 0 → synthesized/keyboard click: keep native toggle.
        // Touch/pen tap on a hybrid device (mq matches on its trackpad) also
        // keeps the native toggle, so the panel opens instead of navigating.
        if (!mq.matches || e.detail === 0 || (e.pointerType && e.pointerType !== 'mouse')) return;
        const url = summary.dataset.url;
        if (url && url !== '#') {
          e.preventDefault();
          window.location.assign(url);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
